export const dateFormatStr = ( date,fmt) => {
    if(date==null || date ==undefined){
        return ''
    }
    return new Date(date).format(fmt)
}
export const caseBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onload = (e) => {
            resolve(e.target.result)
        }
        // readAsDataURL
        fileReader.readAsDataURL(blob)
        fileReader.onerror = () => {
            reject(new Error('blobToBase64 error'))
            
        }
    })
}
